import { useHistory } from "react-router-dom";

import Megaphone from "@/assets/icons/megaphone.svg";
import StatusPage, { StatusPageProps } from "@/containers/StatusPages";
import Button from "@components/Button";

const EmptyArchive: React.FunctionComponent<Partial<StatusPageProps>> = (
  props
) => {
  const history = useHistory();
  return (
    <StatusPage
      icon={Megaphone}
      title={L.ALERT_MENTIONS_UNAVAILABLE_ERROR}
      subtitle={L.ALERT_MENTIONS_UNAVAILABLE_ERROR_SUB}
      {...props}
    >
      <Button
        data-testid="upsale-screen-cta"
        onClick={() => history.push(`${history.location.pathname}?upsale=true`)}
      >
        {L.UPSALE_UPGRADE}
      </Button>
    </StatusPage>
  );
};

export default EmptyArchive;
